export default "__VITE_ASSET__4976c8cf__"